"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.entityNotCleanRule = void 0;
exports.isEntityNotClean = isEntityNotClean;
const zod_1 = require("zod");
const utils_1 = require("@azimutt/utils");
const database_1 = require("../../database");
const databaseUtils_1 = require("../../databaseUtils");
const duration_1 = require("../../helpers/duration");
const rule_1 = require("../rule");
const ruleId = 'entity-not-clean';
const ruleName = 'entity not clean';
const ruleDescription = 'entities having dead rows, analyze lag/last run or vacuum lag/last run exceeding the thresholds';
const CustomRuleConf = rule_1.RuleConf.extend({
    ignores: database_1.EntityId.array().optional(),
    maxDeadRows: zod_1.z.number(),
    maxVacuumLag: zod_1.z.number(),
    maxAnalyzeLag: zod_1.z.number(),
    maxVacuumDelayMs: zod_1.z.number(),
    maxAnalyzeDelayMs: zod_1.z.number(),
}).strict().describe('EntityNotCleanConf');
exports.entityNotCleanRule = {
    id: ruleId,
    name: ruleName,
    description: ruleDescription,
    conf: { level: rule_1.RuleLevel.enum.high, maxDeadRows: 30000, maxVacuumLag: 30000, maxAnalyzeLag: 30000, maxVacuumDelayMs: duration_1.oneDay, maxAnalyzeDelayMs: duration_1.oneDay },
    zConf: CustomRuleConf,
    analyze(conf, now, db, queries, history, reference) {
        const refIgnores = reference.map(r => r.entity).filter(utils_1.isNotUndefined);
        const ignores = refIgnores.concat(conf.ignores?.map(databaseUtils_1.entityRefFromId) || []);
        const dbDate = db.stats?.extractedAt ? new Date(db.stats.extractedAt).getTime() : now;
        return (db.entities || [])
            .filter(e => isEntityNotClean(e, dbDate, conf.maxDeadRows, conf.maxVacuumLag, conf.maxAnalyzeLag, conf.maxVacuumDelayMs, conf.maxAnalyzeDelayMs))
            .filter(e => !ignores.some(i => (0, databaseUtils_1.entityRefSame)(i, (0, databaseUtils_1.entityToRef)(e))))
            .map(e => {
            const reason = isEntityNotClean(e, dbDate, conf.maxDeadRows, conf.maxVacuumLag, conf.maxAnalyzeLag, conf.maxVacuumDelayMs, conf.maxAnalyzeDelayMs);
            const value = isEntityNotCleanValue(e, dbDate, conf.maxDeadRows, conf.maxVacuumLag, conf.maxAnalyzeLag, conf.maxVacuumDelayMs, conf.maxAnalyzeDelayMs);
            return {
                ruleId,
                ruleName,
                ruleLevel: conf.level,
                message: `Entity ${(0, databaseUtils_1.entityToId)(e)} has ${reason} (${value}).`,
                entity: (0, databaseUtils_1.entityToRef)(e),
                extra: { reason, value }
            };
        });
    }
};
function isEntityNotClean(entity, now, maxDeadRows, maxVacuumLag, maxAnalyzeLag, maxVacuumDelayMs, maxAnalyzeDelayMs) {
    if ((entity.kind === undefined || entity.kind === database_1.EntityKind.enum.table) && entity.stats) {
        const s = entity.stats;
        if (s.rowsDead && s.rowsDead > maxDeadRows)
            return 'many dead rows';
        if (s.vacuumLag && s.vacuumLag > maxVacuumLag)
            return 'high vacuum lag';
        if (s.analyzeLag && s.analyzeLag > maxAnalyzeLag)
            return 'high analyze lag';
        if (s.vacuumLast && now - new Date(s.vacuumLast).getTime() > maxVacuumDelayMs)
            return 'old vacuum';
        if (s.analyzeLast && now - new Date(s.analyzeLast).getTime() > maxAnalyzeDelayMs)
            return 'old analyze';
    }
    return '';
}
function isEntityNotCleanValue(entity, now, maxDeadRows, maxVacuumLag, maxAnalyzeLag, maxVacuumDelayMs, maxAnalyzeDelayMs) {
    if ((entity.kind === undefined || entity.kind === database_1.EntityKind.enum.table) && entity.stats) {
        const s = entity.stats;
        if (s.rowsDead && s.rowsDead > maxDeadRows)
            return s.rowsDead;
        if (s.vacuumLag && s.vacuumLag > maxVacuumLag)
            return s.vacuumLag;
        if (s.analyzeLag && s.analyzeLag > maxAnalyzeLag)
            return s.analyzeLag;
        if (s.vacuumLast && now - new Date(s.vacuumLast).getTime() > maxVacuumDelayMs)
            return s.vacuumLast;
        if (s.analyzeLast && now - new Date(s.analyzeLast).getTime() > maxAnalyzeDelayMs)
            return s.analyzeLast;
    }
    return '';
}
//# sourceMappingURL=entityNotClean.js.map